import { render, staticRenderFns } from "./quoteInfo.vue?vue&type=template&id=e2985754&scoped=true&"
import script from "./quoteInfo.vue?vue&type=script&lang=js&"
export * from "./quoteInfo.vue?vue&type=script&lang=js&"
import style0 from "./quoteInfo.vue?vue&type=style&index=0&id=e2985754&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2985754",
  null
  
)

export default component.exports